<template>
<div class="row">
  <btn-upload-file-input
    :ticket="ticket"
    :event="event"
  ></btn-upload-file-input>
  <btn-take-photos
    :ticket="ticket"
    :event="event"
  ></btn-take-photos>
</div>
</template>
<script>
import BtnUploadFileInput from './BtnUploadFileInput'
import BtnTakePhotos from './BtnTakePhotos'
import { mapGetters } from 'vuex'

export default {
  components: {
    BtnTakePhotos,
    BtnUploadFileInput
  },

  data () {
    return {
      showImageCapture: false,
      isLoadingFile: false,
      saving: false,
      selectedFiles: [],
      typeFiles: [],
      binaryFiles: [],
      loading: false
    }
  },

  computed: {
    ...mapGetters('tickets', { ticket: 'ticket' }),
    ...mapGetters('events', { event: 'event' }),
    unableToSend () {
      let blockByWinnerRanking = !this.ticket.winner && this.ticket.event.winnerChoiceMode === 'ranking'
      return this.saving || !this.ticket.stockId || !this.$can('tickets.uploadDoc') || blockByWinnerRanking
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/Actions/TicketsUploadImages.vue